import React from 'react';
import './index.scss';

const VerticalPage = () => (
    <div className="vertical-page"></div>
);

export default VerticalPage;
